import AuthView from '../AuthView.vue';
import Login from '../components/Auth/Login.vue';
import RemindPassword from '../components/Auth/RemindPassword.vue';
import ResetPassword from '../components/Auth/ResetPassword.vue';


export default [
  {
    path: '/',
    name: 'auth',
    component: AuthView,
    meta: {
      public: true,
      onlyWhenLoggedOut: true,
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          public: true,
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: 'remind-password',
        name: 'remindPassword',
        component: RemindPassword,
        meta: {
          public: true,
          onlyWhenLoggedOut: true,
        },
      },
      {
        path: 'reset-password/:token',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
          public: true,
          onlyWhenLoggedOut: true,
        },
      },
    ],
  },
];
